export function extractTextContent(html: string) {
  return html.replaceAll(/<.*?>/g, '').trim();
}
